<template>
	<div class>
		<el-dialog
			:title="addEditTitle"
			:visible.sync="addEditShow"
			:before-close="handleChangeDrawer"
		>
			<div class="pay-mains">
				<el-form
					ref="form"
					:model="form"
					class="demo-ruleForm"
					label-width="260px"
					label-position="left"
				>
					<el-row>
						<el-col :span="12">
							<el-form-item
								label="开支类型"
								prop="categoryId"
								:rules="$rules.required"
								class="el-form-item-update"
							>
								<el-select
									v-model="form.categoryId"
									@change="changeCateGoryId"
                  class="w100b"
								>
									<el-option
										v-for="(item, index) in options"
										:key="index"
										:label="item.name"
										:value="item.id"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								label="金额"
								prop="amount"
								:rules="$rules.money"
								class="el-form-item-update"
							>
								<el-input
									v-model.trim="form.amount"
									placeholder="请输入金额"
									maxlength="8"
								></el-input>
							</el-form-item>
						</el-col>
            
					</el-row>
          <div class="el-form-item-update el-remark" v-if="invoiceDayFlag == 'yes'">
						<div style="padding-bottom: 10px;">
							<span style="color: #f56c6c;">*</span> 开支日期
						</div>
						<el-date-picker
              v-model="form.time"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
					</div>
					<div class="el-form-item-update el-remark">
						<div style="padding-bottom: 10px;">
							<span style="color: #f56c6c;">*</span> 费用明细
						</div>
						<el-input
							v-model="form.applyRemark"
							type="textarea"
							placeholder="请输入费用明细"
							maxlength="150"
							show-word-limit
						></el-input>
					</div>
					<el-form-item
						v-if="imgHide"
						label="上传照片(最多上传5张图片)"
						prop="imgUrlList"
						:rules="$rules.required"
						class="el-form-item-update"
					>
						<!-- v-if="imgHide" -->
						<imgUpload
							@file="getFile"
              :limit="5"
							:fileList="form.imgUrlList"
              @delete="handleDelete"
							module="invoice"
						></imgUpload>
						<p></p>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="back(form)">取消</el-button>
				<el-button type="primary" @click="save">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
import imgUpload from '../../../components/common/modules/upload'
export default {
	mixins: [minxin],
	components: { drawer, imgUpload },
	data() {
		return {
			addEditTitle: '新增开支',
			addEditShow: false,
			imgHide: false, //图片隐藏
			optionsHide: false,
			options: [],

			form: {
				categoryId: '',
        amount: '',
        time: [],
        beginTime: '',
        endTime: '',
				applyRemark: '',
				imgUrlList: [],
			},
      orderInvalidForm: {},
      invoiceDayFlag: ''
		}
	},
	created() {
		this.editInit()
	},
	methods: {
		back() {
			//   this.$router.push("/collectMoney");
			this.$refs['form'].resetFields()
			this.addEditShow = false
		},
		editInit() {
			this.$on('set', function(org) {
				Object.assign(this.$data, this.$options.data())
				if (org) {
					this.$api
						.get(this.$url.invoice.get, { id: org.id })
						.then((res) => {
							if (res) {
                if (res.beginTime && res.endTime) {
                  res.time = [this.formatDay(res.beginTime), this.formatDay(res.endTime)]
                }
								this.form = res
								this.addEditTitle = '编辑开支'
								this.optionsHide = true
								this.formHide = true
								this.setImgHide()
							}
						})
				} else {
					this.addEditTitle = '新增开支'
				}
				this.addEditShow = true
				this.invoiceCategory()
				// this.$api.get(this.$url.orderInfo.get,{
				//     id: org.orderId
				// }).then( res => {
				//     if(res){
				//         this.form = res;
				//         this.form.oxCtime = this.formatDate(this.form.oxCtime);
				//     }
				// })
			})
		},
		invoiceCategory() {
			//发票分类
			this.$api.post(this.$url.invoiceCategory.list).then((res) => {
				if (res) {
					this.options = res
					this.optionsHide = true
					this.setImgHide()
				}
			})
		},
		// 上传组件成功回调
		getFile(res) {
			this.form.imgUrlList.push(res);
		},
    handleDelete(res) {
      this.form.imgUrlList = res.myFileList;
      if (!this.form.id) {
        this.ossMerchatDelImg(res);
      }
    },
		setImgHide() {
			console.log(this.formHide && this.optionsHide)
			if (this.formHide && this.optionsHide) {
        let result = this.options.find(p => p.id == this.form.categoryId)
        if (result) {
          if (result.needImg == "enable") {
            this.imgHide = true;
          } else {
            this.imgHide = false;
          }
          this.invoiceDayFlag = result.invoiceDayFlag
        }
			}
		},
		changeCateGoryId(val) {
			let result = this.options.find(p => p.id == val)
      if (result) {
        if (result.needImg == "enable") {
          this.imgHide = true;
        } else {
          this.imgHide = false;
        }
        this.invoiceDayFlag = result.invoiceDayFlag
      }
		},
		handleChangeDrawer() {
			this.$refs['form'].clearValidate()
			this.addEditShow = false
			this.$emit('change', false)
		},
		save(values) {
			if (!this.form.categoryId) {
				return this.$message.error('请选择开支类别')
			} else if (!this.form.amount) {
				return this.$message.error('请输入金额')
			} else if (this.form.applyRemark == '') {
				return this.$message.error('请输入费用明细')
      } else if (this.invoiceDayFlag && this.invoiceDayFlag == 'yes' && this.form.time.length == 0) {
        return this.$message.error('请选择开支日期')
      }
      if (this.invoiceDayFlag && this.invoiceDayFlag == 'yes' && this.form.time.length > 0) {
        this.form.beginTime = this.form.time[0] || ''
        this.form.endTime = this.form.time[1] || ''
      } else if (this.invoiceDayFlag == 'no') {
        this.form.beginTime = ''
        this.form.endTime = ''
      }
			this.$refs.form.validate((valid, object) => {
				if (valid) {
					this.$api
						.post(this.$url.invoice.save, this.form)
						.then((res) => {
							if (res) {
								this.addEditShow = false
								this.$message.success('操作成功')
								this.$emit('change', true)
							}
						})
						.catch((error) => {})
				}
			})
		},
	},
}
</script>
<style scoped lang="less">
@import '../../../assets/css/edit.less';

/deep/ .el-form-item-img .el-form-item__content {
	width: 100%;
}
.el-remark {
	flex-direction: column;
	height: 100% !important;
	align-items: flex-start !important;
}
/deep/ .el-dialog__header {
	// padding: 20px;
	border-bottom: 1px solid #f5f5f5;
}
.pay-mains {
	padding: 0;
	.el-form-item-update {
		display: flex;
		flex-direction: column;
		padding: 10px 20px;
		margin: 0;
		background: #fff;
		/deep/ .el-form-item__label {
			font-size: 16px;
			font-weight: 500;
		}
		/deep/ .el-form-item__content {
			margin-left: 0 !important;
		}
	}
}
/deep/ .el-dialog {
  width: 640px;
  .el-dialog__body {
    padding: 0 16px 16px;
  }
}

</style>
